<div class="flex flex-col gap-4">
  <div>
    <form [formGroup]="veeForm">
      <app-input-group>
        <label appLabel>{{ 'vee.create.name' | translate }}</label>
        <input type="text" appInput formControlName="name">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'vee.create.estimateAfter' | translate }}</label>
        <input type="number" appInput formControlName="estimateAfter">
      </app-input-group>
    </form>
  </div>

  <app-alert type="info">
    {{ 'vee.create.manualestimation' | translate }}
  </app-alert>


  <div class="flex flex-col gap-4" cdkDropListGroup>
    <div class="bg-gray-100 dark:bg-dark-hover px-3 py-2 rounded">
      {{ 'vee.create.activeestimations' | translate }}
    </div>

    <div
      class="flex flex-col gap-0 rounded border border-gray-200 dark:border-dark-border"
      cdkDropList
      [cdkDropListData]="activeEstimationMethods"
      (cdkDropListDropped)="dropList($event)"
    >
      @if (activeEstimationMethods.length > 0) {
        <table>
          <thead>
          <tr class="bg-gray-50 dark:bg-dark-hover text-sm border-b border-b-gray-200 dark:border-b-dark-border text-gray-500 dark:text-dark-text text-left">
            <th class="p-2 w-8"></th>
            <th class="p-2 flex-grow font-normal">Navn</th>
            <th class="p-2 w-1/5 font-normal">Send målte værdier</th>
            <th class="p-2 w-8"></th>
          </tr>
          </thead>
          <tbody>
            @for (method of activeEstimationMethods; track method.method; let i = $index) {
              <tr
                class="cursor-pointer text-gray-500 dark:text-dark-text font-normal bg-white dark:bg-dark-card border-b border-b-gray-200 dark:border-b-dark-border last-of-type:border-b-0 hover:bg-gray-50 dark:hover:bg-dark-hover text-sm"
                cdkDrag>
                <td
                  class="w-8 text-center align-middle border-r border-gray-200 dark:border-dark-border p-2 bg-gray-50 dark:bg-dark-hover cdk-hide-from-preview"
                >
                  {{ i + 1 }}
                </td>
                <td class="p-2 cdk-full-width">
                  {{ method.title | translate }}
                </td>
                <td class="cdk-hide-from-preview">
                  <div class="flex justify-center items-center">
                    <label>
                      <input type="checkbox" [(ngModel)]="method.estimationMethod" appInput>
                    </label>
                  </div>
                </td>
                <td class="border-l border-gray-200 dark:border-dark-border cdk-hide-from-preview">
                  <a class="flex justify-center w-full" href="#" (click)="$event.preventDefault(); deactivateEstimationMethod(method)">
                    <lucide-icon size="16" [name]="X"></lucide-icon>
                  </a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="bg-white dark:bg-dark-card text-sm px-3 py-2 rounded font-normal text-gray-300 dark:text-dark-muted">
          {{ 'vee.create.noactiveestimations' | translate }}
        </div>
      }
    </div>

    <div class="bg-gray-100 dark:bg-dark-hover px-3 py-2 rounded">
      {{ 'vee.create.availableestimations' | translate }}
    </div>

    <div
      class="flex flex-col gap-0 rounded border border-gray-200 dark:border-dark-border"
      cdkDropList
      [cdkDropListData]="availableEstimationMethods"
      (cdkDropListDropped)="dropList($event)"
    >
      @if (availableEstimationMethods.length > 0) {
        <table>
          <tbody>
            @for (method of availableEstimationMethods; track method.method; let i = $index) {
              <tr
                class="border-b border-b-gray-200 dark:border-b-dark-border last-of-type:border-b-0 font-normal text-sm hover:bg-gray-50 dark:hover:bg-dark-hover text-gray-500 dark:text-dark-text"
                cdkDrag
                (click)="activateEstimationMethod(method)">
                <td class="p-2">
                  {{ method.title | translate }}
                </td>
                <td class="w-8 p-2 border-l border-gray-200 dark:border-dark-border">
                  <div class="cdk-hide-from-preview">
                    <lucide-icon size="16" [name]="Plus"></lucide-icon>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="bg-white dark:bg-dark-card text-sm px-3 py-2 rounded font-normal text-gray-300 dark:text-dark-muted">
          {{ 'vee.create.noavailableestimations' | translate }}
        </div>
      }
    </div>
  </div>
</div>
